/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { checkAppClient, detectDeviceModel } from '@/utils';
import { reportAndLog } from '@/utils/log';
import { Provider } from 'react-redux';
import Taro, { Current, getStorageSync } from '@tarojs/taro';
import memberApi from '@/api/me';
import Config from '@/config/path';
import SentryErrorBoundary from '@/components/sentryErrorBoundary';
// import Glog from '@gh/glog';
import 'taro-ui/dist/style/index.scss'; // 全局引入
import dva from './utils/dva';
import models from './models/index';
import './fonts/iconfont.css';
import './styles/reset.scss';
import './styles/global.scss';
import './app.scss';
import * as PACKAGE from '../package.json';

// eslint-disable-next-line import/no-commonjs
const MobileDetect = require('mobile-detect');

//根据自己的需求实现自己的功能
const dvaApp = dva.createApp({
  initialState: {},
  models: models
});
const store = dvaApp.getStore();

export default class Main extends React.Component {
  async componentDidMount() {
    this.initGlobalConfig();
  }

  async componentDidUpdate() {
    dvaApp.dispatch({
      type: 'global/updateState',
      payload: {
        token: getStorageSync('id_token'),
        location: getStorageSync('h5-location') ? JSON.parse(getStorageSync('h5-location')) : ''
      }
    });
    // setTimeout(async () => {
    //   const clientRes = await checkAppClient();
    //   if (clientRes.isIos || clientRes.isAndroid) {
    //     Taro.hideTabBar();
    //   }
    // }, 200);
  }

  /**
   * 出错监听
   */
  initErrorCatch() {
    if (H5_ENV !== 'dev') {
      window.addEventListener('error', this.onErrorHandler, true);
    }
    // window.onerror = this.onError;
  }
  /**
   * 出错上报
   * @param err
   */
  onErrorHandler(err: any) {
    const errorInfo = {
      message: err.error ? err.error.message : typeof err === 'string' ? err : '',
      stack: err.error ? err.error.stack : '',
      page: window.location.href
    };
    reportAndLog(JSON.stringify(errorInfo), -1);
  }
  /** 全局变量配置 */
  async initGlobalConfig() {
    const app: any = Current.app;

    // 初始化oss信息
    // Glog.initConfig({
    //   // ossConfigUrl: 'https://test.genghuo.com/api/video-mall-app/oss/sts/config',
    //   ossConfigUrl: `${Config.Domain[H5_ENV]}/oss/sts/config`,
    //   publicKey:
    //     '-----BEGIN PUBLIC KEY-----\n' +
    //     'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgG2m5VVtZ4mHml3FB9foDRpDW7Pw\n' +
    //     'Foa+1eYN777rNmIdnmezQqHWIRVcnTRVjrgGt2ndP2cYT7MgmWpvr8IjgN0PZ6ng\n' +
    //     'MmKYGpapMqkxsnS/6Q8UZO4PQNlnsK2hSPoIDeJcHxDvo6Nelg+mRHEpD6K+1FIq\n' +
    //     'zvdwVPCcgK7UbZElAgMBAAE=\n' +
    //     '-----END PUBLIC KEY-----'
    // });

    const md = new MobileDetect(window.navigator.userAgent);
    app.globalData = {
      servicePhone: '', // 客服电话
      mine_entrance_activity_visible: null,
      commonProps: {
        // 埋点公用属性
        aid: '',
        eid: '',
        userId: '',
        userName: '',
        userLabel: '',
        time: '',
        platformType: 3,
        appVersion: '',
        ip: '',
        country: '',
        province: '',
        city: '',
        manufacturer: '',
        model: md.phone(),
        os: md.os(),
        osVersion: md.userAgent(),
        browser: window.navigator.userAgent,
        browserVersion: '',
        isFirstDay: '',
        deviceId: '',
        mobile: ''
      }
    };
    window.entryUrl = window.location.href;
    this.getServicePhone();
    this.initErrorCatch(); // 出错日志记录初始化
    if (getStorageSync('id_token') && H5_ENV !== 'dev') {
      const res = await memberApi.getUserInfo();
      if (res) {
        app.systemInfo.uid = res.data.userId;
      }
    }

    if (H5_ENV === 'dev') {
      // 开发环境注册插件便于调试
      // const vconsole = new VConsole();
      // new VConsole();
    }
  }

  // 获取客服电话
  async getServicePhone() {
    const app: any = Current.app;
    const { code, data } = await memberApi.getServicePhone();
    if (code === 200) {
      app.globalData.mine_entrance_activity_visible = data.mine_entrance_activity_visible;
      app.globalData.servicePhone = data.servicePhoneNum;
    }
  }

  // 按环境加载配置
  buildSentryErrorConfig() {
    if (H5_ENV === 'production') {
      return {
        dsn: 'https://8e377ebac2d947d29f31a0a3654313a7@sentry.genghuo.com/9',
        release: PACKAGE.version,
        autoSessionTracking: false
      };
    }

    return {
      dsn: 'https://39f37983132246a691264f58bd467f09@sentry-develop.genghuo.com/24',
      release: PACKAGE.version,
      autoSessionTracking: false
    };
  }

  // this.props.children 是将要会渲染的页面
  render() {
    return (
      <>
        {H5_ENV !== 'dev' ? (
          <SentryErrorBoundary config={{ ...this.buildSentryErrorConfig() }}>
            <Provider store={store}>{this.props.children}</Provider>
          </SentryErrorBoundary>
        ) : (
          <Provider store={store}>{this.props.children}</Provider>
        )}
      </>
    );
  }
}
